export const decidedArrow = (value: string | null | undefined) => {
	switch (value) {
		case "up":
			return "arrow-up";
		case "down":
			return "arrow-down";
		case "rev-up":
		case "rev-down":
		case null:
		case undefined:
			return "arrow-angle";
	}
};
